import { render, staticRenderFns } from "./Instructions2.vue?vue&type=template&id=6cbe04a8&scoped=true&"
import script from "./Instructions2.vue?vue&type=script&lang=js&"
export * from "./Instructions2.vue?vue&type=script&lang=js&"
import style0 from "./Instructions2.vue?vue&type=style&index=0&id=6cbe04a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe04a8",
  null
  
)

export default component.exports